module.exports = __webpack_public_path__ + "static/media/4431.781b2b01.jpg";